var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverAddMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 18,
    height: 18,
    rx: 5,
    fill: "#253A49",
    stroke: "#253A49",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1656 13.5908L15.4556 9.29079C15.643 9.10454 15.8964 9 16.1606 9C16.4248 9 16.6782 9.10454 16.8656 9.29079C16.9593 9.38375 17.0337 9.49435 17.0845 9.61621C17.1353 9.73807 17.1614 9.86878 17.1614 10.0008C17.1614 10.1328 17.1353 10.2635 17.0845 10.3854C17.0337 10.5072 16.9593 10.6178 16.8656 10.7108L11.8656 15.7108C11.6793 15.8955 11.4279 15.9997 11.1656 16.0008C11.034 16.0016 10.9035 15.9763 10.7817 15.9266C10.6599 15.8768 10.549 15.8035 10.4556 15.7108L8.10565 13.3508C8.00097 13.2612 7.91595 13.1508 7.85592 13.0268C7.7959 12.9027 7.76217 12.7676 7.75685 12.6299C7.75153 12.4921 7.77474 12.3548 7.82501 12.2265C7.87529 12.0982 7.95154 11.9816 8.049 11.8841C8.14645 11.7867 8.263 11.7104 8.39133 11.6602C8.51965 11.6099 8.65698 11.5867 8.7947 11.592C8.93242 11.5973 9.06756 11.6311 9.19162 11.6911C9.31568 11.7511 9.426 11.8361 9.51565 11.9408L11.1656 13.5908Z",
    fill: "#CCCBFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverAddMark);
export default __webpack_public_path__ + "static/media/hover-add-mark.b43ba8b9b2c971fef311b485c660ae08.svg";
export { ForwardRef as ReactComponent };